import React, {
	useCallback,
	useEffect,
	useLayoutEffect,
	useState,
} from 'react';
import { useHistory } from 'react-router-dom';

import addIco from '../../assets/add.svg';
import dpDeleteIco from '../../assets/delete.svg';
import displayPicture from '../../assets/dp.jpg';
import dpUploadIco from '../../assets/dp_upload.svg';
import editAward from '../../assets/edit_award.png';
import addSM from '../../assets/themes/ys-classic/addsm.png';
import Awards from '../../components/awards';
import CropModal from '../../components/CropModal';
import Loading from '../../components/LoadingNew';
import EditButton from '../../components/options/EditButton';
import EditButtonTwo from '../../components/options/EditButtonTwo';
import RemoveButton from '../../components/options/RemoveButton';
import SettingGearBtn from '../../components/options/SettingGearBtn';
import SideMenu from '../../components/options/SideMenu';
import Photos from '../../components/Photos';
import Video from '../../components/Video';
import ViewImage from '../../components/viewImage';
import { PROVIDERS } from '../../constants/Constant';

const Main = ({
	user,
	getUserInfo,
	match: { params },
	editable,
	uploadImage,
	deleteProfileImage,
	showDialog,
	removeSocialMedia,
	editModal,
	removeLink,
	removeAchievement,
	removePhoto,
	updateProfile,
}) => {
	useEffect(() => {
		getUserInfo(
			{
				userName: params?.username,
			},
			sus => {
				console.log('sus', sus);
			},
			err => {
				console.log(err);
			}
		);
	}, []);
	const [state, setstate] = useState([0, 0]); //!
	const [videoWidth, setVideoWidth] = useState<any>(720);
	const [editStateTwo, setEditStateTwo] = useState(false);
	const [editingSocial, setEditingSocial] = useState(false);
	const [editingLinks, setEditingLinks] = useState(false);
	const [editingAchie, seteditingAchie] = useState(false);
	const [editingPhoto, seteditingPhoto] = useState(false);

	const videoRef = useCallback(node => {
		if (!node) return;
		setVideoWidth(node.clientWidth);
		const updateSize = () => {
			setVideoWidth(node.clientWidth);
		};
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	const history = useHistory();

	const [upImg, setUpImg] = useState<any>(null);

	const [isView, setView] = useState(false);

	const [isSideMenu, setSideMenu] = useState(false);

	const onSelectFile = e => {
		if (e.target.files && e.target.files.length > 0) {
			const reader = new FileReader();
			reader.addEventListener('load', () => setUpImg(reader.result));
			reader.readAsDataURL(e.target.files[0]);
		}
	};

	const [photo, setPhoto] = useState(null);

	const onPhotoSelectFile = e => {
		if (e.target.files && e.target.files.length > 0) {
			const formData = new FormData();
			formData.append('name', 'dp');
			formData.append('image', e.target.files[0]);

			uploadImage(
				{ data: formData },
				sus => {
					console.log('sus', sus);
				},
				err => {
					console.log(err);
				}
			);
		}
	};

	useLayoutEffect(() => {
		const updateSize = () => {
			setstate([window.innerWidth, window.innerHeight]);
		};
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	function handleView(photo) {
		setView(!isView);
		setPhoto(photo);
	}

	function handleEditStateTwo(name) {
		setEditStateTwo(!editStateTwo);
		if (name === 'socialMedia') setEditingSocial(!editingSocial);
		if (name === 'links') setEditingLinks(!editingLinks);
		if (name === 'achie') seteditingAchie(!editingAchie);
		if (name === 'photos') seteditingPhoto(!editingPhoto);
	}

	function handleLeft() {
		let currIndex = 0;

		for (const [index, img] of (user?.photos).entries()) {
			if (img.url === photo) currIndex = index;
			if (currIndex - 1 < 0) {
				setPhoto(user?.photos[user?.photos.length - 1].url);
				continue;
			}
			setPhoto(user?.photos[currIndex - 1].url);
		}
	}
	function handleRight() {
		let currIndex = 0;

		for (const [index, img] of (user?.photos).entries()) {
			if (img.url === photo) currIndex = index;
			if (currIndex + 1 > user.photos.length - 1) {
				setPhoto(user?.photos[0].url);
				continue;
			}
			setPhoto(user?.photos[currIndex + 1].url);
		}
	}
	const handleRemoveSocialMedia = item => {
		showDialog({
			appAlert: true,
			title: 'Are you sure?',
			msg: 'Do you want to delete this social media from your webpage?',
			leftBtn: 'Yes',
			rightBtn: 'No',
			leftAction: () => {
				removeSocialMedia(
					item?._id,
					sus => {
						console.log('sus', sus);
					},
					err => {
						console.log(err);
					}
				);
			},
		});
	};

	const handleRemoveLinks = item => {
		showDialog({
			appAlert: true,
			title: 'Are you sure?',
			msg: 'Do you want to delete this link from your webpage?',
			leftBtn: 'Yes',
			rightBtn: 'No',
			leftAction: () => {
				removeLink(
					item?._id,
					sus => {
						console.log('sus', sus);
					},
					err => {
						console.log(err);
					}
				);
			},
		});
	};

	const handleRemovePhotos = item => {
		showDialog({
			appAlert: true,
			title: 'Are you sure?',
			msg: 'Do you want to delete this photo from your webpage?',
			leftBtn: 'Yes',
			rightBtn: 'No',
			leftAction: () => {
				removePhoto(
					{ id: item?._id, hash: item?.hash },
					sus => {
						console.log('sus', sus);
					},
					err => {
						console.log(err);
					}
				);
			},
		});
	};

	const handleRemoveAche = item => {
		showDialog({
			appAlert: true,
			title: 'Are you sure?',
			msg: 'Do you want to delete this achievemet from your webpage?',
			leftBtn: 'Yes',
			rightBtn: 'No',
			leftAction: () => {
				removeAchievement(
					item?._id,
					sus => {
						console.log('sus', sus);
					},
					err => {
						console.log(err);
					}
				);
			},
		});
	};

	const handleDeleteImg = () => {
		showDialog({
			appAlert: true,
			title: 'Are you sure?',
			msg: 'Do you want to delete profile photo?',
			leftBtn: 'Yes',
			subtitle:
				'Your profile photo will be changed back to Webbler default profile photo.',
			rightBtn: 'No',
			leftAction: () => {
				deleteProfileImage(
					user?.profilePicture?.hash,
					sus => {
						console.log('sus', sus);
					},
					err => {
						console.log(err);
					}
				);
			},
		});
	};

	const removeVideo = () => {
		showDialog({
			title: 'Are you sure?',
			msg: 'Do you want to delete this video?',
			leftBtn: 'Yes',
			rightBtn: 'No',
			leftAction: () => {
				updateProfile(
					{
						['videoRef']: '',
					},
					data => {
						console.log('success');
					},

					err => {
						console.log(err);
					}
				);
			},
		});
	};

	if (user?.loading) {
		return <Loading />;
	}

	return (
		<div className='App'>
			{upImg && (
				<CropModal
					upImg={upImg}
					handleEditState={() => {
						setUpImg(null);
					}}
				/>
			)}
			{isView && (
				<ViewImage
					img={photo}
					handleViewState={handleView}
					handleLeft={handleLeft}
					handleRight={handleRight}
				/>
			)}

			<div className='box'>
				{isSideMenu && <SideMenu closeBtnHandler={() => setSideMenu(false)} />}

				{editable && <SettingGearBtn clickHandler={() => setSideMenu(true)} />}
				<div className='profile__group'>
					<div className='profile__card'>
						<div className='dp_edit_container'>
							<div className='profile-picture-wrapper'>
								<div
									className='profile__picture'
									style={{
										backgroundImage: `url(
												${user?.profilePicture?.url ? user?.profilePicture?.url : displayPicture}
											)`,
									}}
								></div>
								{editable && (
									<div className='dp__upload'>
										<label className='file-button' htmlFor='file2'>
											<img src={dpUploadIco} alt='' />
										</label>
										<input
											type='file'
											name='file2'
											id='file2'
											accept='image/*'
											onChange={e => onSelectFile(e)}
										/>
										{user?.profilePicture?.url && (
											<label className='file-button' onClick={() => handleDeleteImg()}>
												<img src={dpDeleteIco} alt='' />
											</label>
										)}
									</div>
								)}
							</div>
						</div>
						<div className='name__group'>
							<h5 className='profile__name'>
								{user?.name === '' ? user?.userName : user?.name}
								{editable && (
									<EditButton
										handleEditState={() =>
											editModal({
												name: 'name',
												title: 'Display name',
											})
										}
									/>
								)}
							</h5>
							<h5 className='username'>
								@{user === null ? 'Jane Doe' : user?.userName}
								{editable && (
									<EditButton
										handleEditState={() =>
											editModal({
												name: 'userName',
												title: 'Username',
												handleEditState: v => {
													console.log(v);
												},
											})
										}
									/>
								)}
							</h5>
							{(editable || (user?.occupation && user?.occupation != '')) && (
								<span className='professions'>
									{user?.occupation === ''
										? 'Enter your occupation here!'
										: user?.occupation}
									{editable && (
										<EditButton
											handleEditState={() =>
												editModal({ title: 'Occupation', name: 'occupation' })
											}
										/>
									)}
								</span>
							)}
						</div>
					</div>
				</div>
				<hr className='seperator'></hr>
				{(editable || (user?.bio && user?.bio != '')) && (
					<div className='bio_wrap'>
						<span style={{ whiteSpace: 'pre-line' }} className='bio'>
							{user?.bio === '' ? 'Enter your bio here!' : user?.bio}
						</span>
						{editable && (
							<EditButton
								handleEditState={() => editModal({ name: 'bio', title: 'Bio' })}
							/>
						)}
					</div>
				)}
				{(editable || user?.socialLinks?.length > 0) && (
					<div className='social_links_wrap'>
						<span className='caption'>
							Social Media
							{editable && (
								<EditButtonTwo
									editState={editingSocial}
									handleEditStateTwo={() => handleEditStateTwo('socialMedia')}
								/>
							)}
						</span>
						<div className='ys-classic'>
							{user?.socialLinks.map((item, index) => {
								const provider = item?.provider;
								const icon =
									PROVIDERS[provider].icon != null
										? PROVIDERS[provider].icon
										: PROVIDERS.website.icon;
								return (
									<a
										key={index}
										className='social__group'
										href={editingSocial ? null : item?.link}
									>
										{editingSocial && (
											<RemoveButton
												handleRemoveState={() => handleRemoveSocialMedia(item)}
											/>
										)}
										<img src={icon} alt='' />
									</a>
								);
							})}
							{editable && (
								<div
									onClick={() =>
										editModal({
											name: 'socialMedia',
											title: 'Social Media',
										})
									}
									className='social__group'
								>
									<img src={addSM} alt='' />
								</div>
							)}
						</div>
					</div>
				)}
				{(editable || user?.links?.length > 0) && (
					<div className='links-wrap'>
						<span className='caption'>
							Links
							{editable && (
								<EditButtonTwo
									editState={editingLinks}
									handleEditStateTwo={() => handleEditStateTwo('links')}
								/>
							)}
						</span>
						{user?.links?.map((item, index) => {
							return (
								<div className='link-item-wrap'>
									<a
										target='_blank'
										key={index}
										rel='noopener nofollow'
										className='link-item'
										href={editingLinks ? null : item?.url}
									>
										{editingLinks && (
											<RemoveButton handleRemoveState={() => handleRemoveLinks(item)} />
										)}
										<img
											className='link-image'
											data-src={item?.url}
											src={item.icon ? item?.icon : addSM}
											alt={item?.title}
										></img>
										<span className='item-title'>{item?.title}</span>
									</a>
								</div>
							);
						})}
						{editable && (
							<div
								className='link-item-wrap'
								onClick={() => editModal({ name: 'links', title: 'Links' })}
							>
								<a target='_blank' rel='noopener nofollow' className='link-item'>
									<img
										className='link-image'
										data-src={addSM}
										src={addSM}
										alt={'Add new link'}
									></img>
									<span className='item-title'>{'Add new link'}</span>
								</a>
							</div>
						)}
					</div>
				)}
				{(editable || user?.achievement?.length > 0) && (
					<div className='awards_container'>
						<span className='caption'>
							Achievements
							{editable && (
								<EditButtonTwo
									editState={editingAchie}
									handleEditStateTwo={() => handleEditStateTwo('achie')}
								/>
							)}
						</span>
						<div className='award-wrapper'>
							<div className='award-corousel'>
								{user?.achievement?.map((item, index) => (
									<Awards
										key={index}
										state={editingAchie}
										handleRemove={() => handleRemoveAche(item)}
										title={item?.title}
										subTitle={item?.subTitle}
										description={item?.summary}
									/>
								))}
								{editable && (
									<div
										className={`award editAward`}
										onClick={() => {
											editModal({ name: 'awards', title: 'Achievements' });
										}}
									>
										<img src={editAward} alt={'edit'} />
									</div>
								)}
							</div>
						</div>
					</div>
				)}
				{(editable || user?.photos?.length > 0) && (
					<div className='photos_container'>
						<span className='caption'>
							Photos
							{editable && (
								<EditButtonTwo
									editState={editingPhoto}
									handleEditStateTwo={() => handleEditStateTwo('photos')}
								/>
							)}
						</span>
						<div className='photos-wrapper'>
							<div className='photos-corousel'>
								{user?.photos?.map((item, index) => (
									<Photos
										key={index}
										state={editingPhoto}
										handleRemove={() => handleRemovePhotos(item)}
										photo={item?.url}
										handleView={handleView}
									/>
								))}
								{editable && (
									<div className='photo editPhoto'>
										<label className='file-button' htmlFor='file'>
											<img src={editAward} alt='' />
										</label>
										<input
											type='file'
											name='file'
											id='file'
											accept='image/*'
											onChange={e => {
												showDialog({
													title: 'Are you sure?',
													msg: 'Do you want to upload this photo?',
													leftBtn: 'Yes',
													rightBtn: 'No',
													leftAction: () => {
														onPhotoSelectFile(e);
													},
												});
											}}
										/>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
				{(editable || (user?.videoRef && user?.videoRef != '')) && (
					<div className='video_container' ref={videoRef}>
						<span className='caption'>
							Video
							{editable && (
								<EditButton
									handleEditState={() =>
										editModal({ name: 'videoRef', title: 'Add Video' })
									}
								/>
							)}
						</span>
						<div className='video-container'>
							{user?.videoRef && editable && (
								<RemoveButton handleRemoveState={removeVideo} />
							)}
							<div className='video-wrapper'>
								{user?.videoRef && user?.videoRef !== '' && (
									<Video
										theme={`ys-classic`}
										video={user?.videoRef}
										width={`${videoWidth}px`}
										height={`${(videoWidth / 1280) * 720}px`}
									/>
								)}
								{(!user?.videoRef || user?.videoRef === '') && (
									<div
										className='video-placeholder'
										style={{ height: `${(videoWidth / 1280) * 720}px` }}
									>
										<button
											className='add-video'
											onClick={e => editModal({ name: 'videoRef', title: 'Add Video' })}
										>
											<img src={addIco} alt='' />
										</button>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
				<div className='ask'>
					<p onClick={() => history.push('/')}>
						<i className='fa fa-plus' aria-hidden='true' />
						&nbsp; Made with Webbler
					</p>
				</div>
			</div>
		</div>
	);
};

export default Main;
